module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav-container"
  }, [_c('div', {
    staticClass: "nav-wrapper",
    style: ([_vm.containerSize, _vm.navTransform])
  }, [_c('ul', {
    staticClass: "nav-tabbar"
  }, _vm._l((_vm.navs), function(nav, index) {
    return _c('li', {
      staticClass: "nav-item",
      style: (_vm.setItem(index)),
      on: {
        "click": function($event) {
          _vm.setNav(index)
        }
      }
    }, [_c('a', {
      style: (_vm.anchorStyle),
      attrs: {
        "href": nav.href || "javascript:void(0)"
      }
    }, [(nav.icon) ? _c('span', {
      staticClass: "iconfont",
      class: nav.icon
    }) : _vm._e(), (nav.label) ? _c('span', {
      staticClass: "nav-item-label"
    }, [_vm._v(_vm._s(nav.label))]) : _vm._e()])])
  }))]), _c('div', {
    staticClass: "nav-toggle",
    style: (_vm.colorT),
    on: {
      "click": _vm.toggle
    }
  }, [_vm._v(_vm._s(_vm.isOpen ? '-' : '+'))]), _c('div', {
    staticClass: "nav-overlay",
    class: _vm.isOpen ? "on-overlay" : "",
    on: {
      "click": _vm.toggle
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8e0279a6!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/circular-nav.vue
// module id = 59
// module chunks = 1